<template>
  <div class="v-d-learn-more">
    <img class="deco-img top-deco" src="@/assets/img/index/bg_kv_3_white.svg" />
    <img class="deco-img trees-deco" src="@/assets/img/index/deco_trees.png" />

    <div class="v-d-learn-more__content g-content">
      <div class="wrap">
        <div class="title">
          <p class="title__text">想進一步了解我們嗎，歡迎隨時聯繫</p>
        </div>

        <div class="btn-wrap">
          <div class="btn-wrap__btn-box">
            <pr-button shadow @click="toPage('donate-channel')">我要捐款</pr-button>
          </div>
          <div class="btn-wrap__btn-box">
            <pr-button shadow @click="toPage('help')">需要幫助</pr-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import PrButton from '@/components/Global/PrButton.vue';

export default defineComponent({
  name: 'LearnMore',
  components: {
    PrButton,
  },
  setup() {
    const router = useRouter();

    const toPage = (name) => {
      router.push({ name });
    };

    return {
      toPage,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';
.v-d-learn-more {
  background-image: url('~@/assets/img/index/bg_kv_3.png');
  background-size:cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  &__content {
    @include padding(50px 0);
    height: 100%;
    @include flex(center);
  }
}

.top-deco {
  width: 100%;
  @include position(tl, -1px, 0);
}

.trees-deco {

  @include position(tr, -90px, 100px);
}

.title {
  &__text {
    @include font-style($c-white, 20, bold);
    text-shadow: 0px 3px 6px #00000029;
    text-align: center;
  }
}

.btn-wrap {
  @include flex(center, center, column);
  // width: 100%;
  margin-top: 30px;

  &__btn-box {
      // width: 100%;
      @include flex(center);

    & + & {
      margin-top: 20px;
    }
  }
}

@media screen and (min-width: $tablet) {
  .v-d-learn-more {
    &__content {
      @include padding(75px 0);
    }
  }

  .title {
    &__text {
      @include font-style($c-white, 25, bold);
    }
  }

  .btn-wrap {
    @include flex(center);
    margin-top: 30px;

    &__btn-box {
      & + & {
        margin-top: 0px;
        margin-left: 20px;
      }
    }
  }
}

@media screen and (min-width: $tablet) {
  .v-d-learn-more {
    &__content.g-content {
      @include padding(160px 0);
    }
  }
}

@media screen and (min-width: $sm-pc) {
  .title {
    &__text {
      @include font-style($c-white, 35, bold, 3.5px);
    }
  }
}
</style>
